import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { DeviceEffects } from './device.effects';
import { deviceReducer } from './device.reducer';
import { DeviceRebootEffects } from './device-reboot.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('devices', deviceReducer),
    EffectsModule.forFeature([DeviceRebootEffects, DeviceEffects]),
  ],
  providers: [],
})
export class DeviceStoreModule {}
